import React from 'react';
import './nav.css';
import {AiOutlineHome} from 'react-icons/ai'
import {AiOutlineUser} from 'react-icons/ai'
import {GiNetworkBars} from 'react-icons/gi'
import {BiMessageEdit} from 'react-icons/bi'
import {BsPatchCheck} from 'react-icons/bs'
import {RiSuitcaseLine} from 'react-icons/ri'
import {useState} from 'react'

const Nav = () => {
  const [activeNow, setActiveNow] = useState('#home')
  return (
    <nav>
        <a href="#home" onClick={()=> setActiveNow('#home')} className={activeNow === '#home' ? 'active' : ''}><AiOutlineHome/></a>
        <a href="#about" onClick={()=> setActiveNow('#about')} className={activeNow === '#about' ? 'active' : ''}><AiOutlineUser/></a>
        <a href="#accomplishments" onClick={()=> setActiveNow('#accomplishments')} className={activeNow === '#accomplishments' ? 'active' : ''}><RiSuitcaseLine/></a>
        <a href="#credentials" onClick={()=> setActiveNow('#credentials')} className={activeNow === '#credentials' ? 'active' : ''}><BsPatchCheck/></a>
        <a href="#experience" onClick={()=> setActiveNow('#experience')} className={activeNow === '#experience' ? 'active' : ''}><GiNetworkBars/></a>
        <a href="#contact" onClick={()=> setActiveNow('#contact')} className={activeNow === '#contact' ? 'active' : ''}><BiMessageEdit/></a>
    </nav>
  )
}

export default Nav
